go-toc {
  --toc-border-width: 0.25rem;
  --toc-border-color: var(--go-color-primary-900);
  --toc-border-gap: 2rem;
  --toc-padding: 1.5rem 0;

  display: block;
  .go-toc {
    padding: var(--toc-padding);
    nav {
      position: relative;
    }
  }
  .go-toc-line {
    position: absolute;
    top: 0;
    left: 0;
    width: var(--toc-border-width);
    background: var(--toc-border-color);
    border-radius: var(--radius-round);
    height: 100%;
  }
  .go-toc-title {
    padding-left: var(--toc-border-gap);
    margin-bottom: 1rem;
  }
  .go-toc-list {
    padding-left: var(--toc-border-gap);
    list-style: none;
    margin: 0;
    go-link {
      --nav-link-current-bar-width: 0;
    }
  }
}
